import { useSelector } from 'react-redux';
import { LocationIntegrationName, ProfileName, AccIntegrationName } from '@constants/integrations';
import { POST_CHANNEL } from '@constants/social-posts';
import { useLocations } from './useLocations';

export const useSocialPostsPlatforms = () => {
    const account = useSelector(state => state.account?.account);
    const GOOGLE_CONNECTED = account?.integrations.find(i => i.type === AccIntegrationName.Google)?.isActive;
    const FACEBOOK_CONNECTED = account?.integrations.find(i => i.type === AccIntegrationName.Facebook)?.isActive;

    const { locationsMap } = useLocations();

    const BaseFilter = {
        integrationBased: false,
    };
    const getPostsPlatformsState = (locationsIds, filter) => {
        const updatedFilter = { ...BaseFilter, ...filter };
        return locationsIds
            ?.map(companyId => locationsMap[companyId])
            ?.filter(Boolean)
            ?.flatMap(location => location.profiles)
            .reduce(
                (prev, acc) => {
                    if (acc.type === LocationIntegrationName.Google) {
                        return { ...prev, googleConnected: updatedFilter.integrationBased ? GOOGLE_CONNECTED : true };
                    }
                    if (acc.type === LocationIntegrationName.Facebook) {
                        return {
                            ...prev,
                            facebookConnected: updatedFilter.integrationBased ? FACEBOOK_CONNECTED : true,
                        };
                    }
                    if (acc.type === ProfileName.Instagram) {
                        return {
                            ...prev,
                            instagramConnected: updatedFilter.integrationBased ? FACEBOOK_CONNECTED : true,
                        };
                    }
                    return prev;
                },
                { googleConnected: false, facebookConnected: false, instagramConnected: false },
            );
    };

    const getPlatformsOptions = (locationsIds, filter = {}) => {
        const { googleConnected, facebookConnected, instagramConnected } = getPostsPlatformsState(locationsIds, filter);
        return [
            ...(googleConnected ? [{ value: POST_CHANNEL.GOOGLE, label: 'Google' }] : []),
            ...(facebookConnected ? [{ value: POST_CHANNEL.FACEBOOK, label: 'Facebook' }] : []),
            ...(facebookConnected && instagramConnected ? [{ value: POST_CHANNEL.INSTAGRAM, label: 'Instagram' }] : []),
        ];
    };

    const getAllPlatformsOptions = () => {
        return [
            { value: POST_CHANNEL.GOOGLE, label: 'Google' },
            { value: POST_CHANNEL.FACEBOOK, label: 'Facebook' },
            { value: POST_CHANNEL.INSTAGRAM, label: 'Instagram' },
        ];
    };

    const getConnectedPlatforms = (locationsIds, filter = {}) => {
        const { googleConnected, facebookConnected, instagramConnected } = getPostsPlatformsState(locationsIds, filter);
        return [
            ...(googleConnected ? [POST_CHANNEL.GOOGLE] : []),
            ...(facebookConnected ? [POST_CHANNEL.FACEBOOK] : []),
            ...(facebookConnected && instagramConnected ? [POST_CHANNEL.INSTAGRAM] : []),
        ];
    };

    return { getPlatformsOptions, getConnectedPlatforms, getAllPlatformsOptions };
};
